AppBase.module(
  'Components.PhoneMulticomplete',
  function (Module, App, Backbone, Marionette, $, _) {
    'use strict'

    var LayoutView = App.Views.LayoutView.extend({
      className: 'phone_multicomplete',
      template: 'phone_multicomplete/layout',

      events: {
        click: 'focus',
      },

      childEvents: {
        'search:blurred': 'searchBlurred',
        'search:focused': 'searchFocused',
        'search:value:changed': 'searchChanged',
        'search:value:reset': 'searchReset',
        'suggestions:added': 'suggestionAdded',
      },

      collectionEvents: {
        'add remove': 'enforceCollectionLimit',
      },

      behaviors: {
        SN_Theme: {},
      },

      regions: {
        search: '.js-searchWrapper',
        suggestions: '.js-suggestionsWrapper',
        tokens: '.js-tokensWrapper',
      },

      initialize: function (options) {
        App.Views.LayoutView.prototype.initialize.call(this, options)

        _.bindAll(this, 'searchDefault')

        this.search_view = null
        this.suggestions_view = null
      },

      onShow: function () {
        this.renderSearch()
        this.renderSuggestions()
        this.renderTokens()
      },

      /**
       * Inserts a Supernova `SearchInput` view.
       *
       * @private
       */
      renderSearch: function () {
        var view = new snui.SearchInput({
          input_options: {
            minLength: 2,
          },
          // @todo I18n
          placeholder: 'Enter a phone number',
          theme: this.getOption('theme'),
        })
        this.search_view = view

        this.getRegion('search').show(view)
      },

      /**
       * If the `default_number` is set automatically search for it.
       *
       * @private
       */
      searchDefault: function () {
        var number = this.getOption('default_number')

        if (!number || !number.length) return

        this.search_view.triggerMethod('change', number)
      },

      /**
       * Notify the suggestions view that the search input has lost focus.
       *
       * @private
       */
      searchBlurred: function () {
        this.suggestions_view.triggerMethod('suggestions:hide')
      },

      /**
       * Notify the suggestions view that the user has typed in the search
       * input.
       *
       * @param {Backbone.View} view - Ignored.
       * @param {string} value - Updated search value.
       * @private
       */
      searchChanged: function (view, value) {
        if (!value.length) return

        this.suggestions_view.triggerMethod('search:update', value)
      },

      /**
       * Notify the suggestions view that the search input has been focused.
       *
       * @private
       */
      searchFocused: function () {
        this.suggestions_view.triggerMethod('suggestions:show')
      },

      /**
       * Notify the suggestions view that the search has been reset.
       *
       * @private
       */
      searchReset: function () {
        this.suggestions_view.triggerMethod('search:reset')
      },

      /**
       * Disable the search input if `max_items` numbers are in the collection
       * (provided `max_items` is set).
       *
       * @private
       */
      enforceCollectionLimit: function () {
        var limit = this.getOption('max_items')
        var method

        if (!limit) return

        method = this.collection.length >= limit ? 'disable' : 'enable'

        this.search_view.triggerMethod(method)
      },

      /**
       * Inserts the `Suggestions` view.
       *
       * @private
       */
      renderSuggestions: function () {
        var view = new Module.Suggestions({
          collection: this.collection,
        })
        this.suggestions_view = view

        this.listenTo(view, 'show', this.searchDefault)

        this.getRegion('suggestions').show(view)
      },

      /**
       * Clear the search input when a suggestion has been added.
       *
       * @private
       */
      suggestionAdded: function () {
        this.search_view.trigger('change', '')
      },

      /**
       * Inserts the `Tokens` view.
       *
       * @private
       */
      renderTokens: function () {
        var view = new Module.Tokens({
          collection: this.collection,
          model: this.model,
          theme: this.getOption('theme'),
        })
        this.getRegion('tokens').show(view)

        this.enforceCollectionLimit()
      },
    })
    Module.LayoutView = LayoutView
  }
)
